import { useMergedRef } from '@/hook';

import { TRACK_TYPE } from '../VBaseTrack';
import { VFlex } from '../VFlex';
import { SLIDER_THUMB_SIZE } from '../VSlider';
import { useVSliderContext, useVSliderThumb } from '../VSlider/hook';
import { twStyle } from '../VSlider/style';
import { useVFrameTrackSliderContext } from './hook';

export const VFrameTrackSliderThumb = ({
  ref,
  thumbValue,
}: React.ComponentPropsWithRef<'div'> & {
  thumbValue: number;
}) => {
  const { disabled, normalizedMarkerItemMap, min, max, readOnly, step } =
    useVSliderContext<TRACK_TYPE.RANGE>();
  const { value, variant, $thumbRef, setValue } = useVFrameTrackSliderContext();
  const { $thumb, thumbThresholdTx } = useVSliderThumb({
    disabled,
    normalizedMarkerItemMap,
    /**
     * @description VFrameSlider 의 value 이기 때문에 항상 single value 이므로 [[value]] 로 가져와야 함
     */
    normalizedValue: [[value]],
    max,
    min,
    readOnly,
    step,
    thumbValue,
    type: TRACK_TYPE.NORMAL,
    value,
    setValue,
  });
  const mergedRef = useMergedRef(ref, $thumb, $thumbRef);
  const style = twStyle({
    disabled,
    readOnly,
    variant,
  });

  return (
    <VFlex
      ref={mergedRef}
      aria-disabled={disabled}
      aria-label="v-frame-slider-thumb"
      aria-readonly={readOnly}
      aria-valuenow={thumbValue}
      aria-valuemax={thumbThresholdTx[1]}
      aria-valuemin={thumbThresholdTx[0]}
      className={style.thumb}
      style={
        {
          '--tx': 0,
          '--thumb-size': `${SLIDER_THUMB_SIZE}px`,
        } as React.CSSProperties
      }
      justify="center"
      items="center"
    />
  );
};

VFrameTrackSliderThumb.displayName = 'VFrameTrackSliderThumb';
